<template>
  <div class="bigdiv">
    <div class="twodiv">
      <div >
        <p><h2>登录</h2></p><br>
      </div>
      <div>
        <Input v-model="username" placeholder="账号" style="width: 300px"></Input><br><br>
        <Input v-model="password" placeholder="密码" style="width: 300px" type="password"></Input><br><br><br>
      </div>
      <div>
        <Button type="info" @click="executelogin()" class="but">登录</Button>
      </div>
      <div style="position: absolute;left: 38%;bottom: 1%;">
        <a href="https://beian.miit.gov.cn/" target="_blank" style="font-size: 14px;color: #4d4949;">Copyright© 2017 - 2023 | 时间里的 .AllRightsReserved | 辽ICP备17011241号-2</a> 
      </div>
    </div>
  </div>
</template>
<style scoped>
@media screen and (max-width: 1920px) {
    .bigdiv{
      width:100%;
      height: 100vh;
      background:url(https://resource.guanchao.site/uploads/public/bg_2.jpg) left no-repeat;
      background-size:cover;
    }
}
@media screen and (max-width: 1880px) {
    .bigdiv{
      width:100%;
      height: 100vh;
      background:url(https://resource.guanchao.site/uploads/public/bg_2.jpg) left no-repeat;
      background-size:cover;
    }
}
@media screen and (max-width: 1366px) {
    .bigdiv{
      width:100%;
      height: 100vh;
      background:url(https://resource.guanchao.site/uploads/public/bg_2.jpg) left no-repeat;
      background-size:cover;
    }
}
@media screen and (max-width: 1326px) {
    .bigdiv{
      width:100%;
      height: 100vh;
      background:url(https://resource.guanchao.site/uploads/public/bg_2.jpg) left no-repeat;
      background-size:cover;
    }
}
  .but{
    width:60px;
    height:30px;
  }

  .twodiv{
    margin-top: 200px;
    margin-left: 300px;
  }
</style>
<script>
import login from '@/assets/js/views/login/login';

export default {
  ...login,
};
</script>

